<template>
    <footer class="footer">
        <div class="container">
            <div class="top">
                <!-- 左侧：logo + 联系方式 -->
                <div class="col brand">
                    <div class="brand-row">
                        <img class="brand-mark" src="../static/logo.webp" alt="技明电器" />
                        <div class="brand-name">
                            <div class="cn">余姚市技明电器有限公司</div>
                            <div class="en">YUYAO JIMING ELECTRIC APPLIANCE CO., LTD.</div>
                        </div>
                    </div>

                    <div class="contact">
                        <div class="item">
                            <span class="ico">☎</span>
                            <span class="txt">咨询热线：13958349372</span>
                        </div>
                        <div class="item">
                            <span class="ico">✉</span>
                            <span class="txt">业务邮箱：17371988805@163.com</span>
                        </div>
                        <div class="item">
                            <span class="ico">📍</span>
                            <span class="txt">公司地址：余姚市凤山街道永丰村冯严34号
</span>
                        </div>
                    </div>
                </div>

                <!-- 中间：导航列（3列） -->
                <div class="col nav">
                    <div class="nav-col" v-for="g in navGroups" :key="g.title">
                        <div class="nav-title">{{ g.title }}</div>
                        <component
                            :is="l.href ? 'a' : 'router-link'"
                            v-for="l in g.links"
                            :key="l.text"
                            class="nav-link"
                            :href="l.href || undefined"
                            :to="l.to"
                        >
                            {{ l.text }}
                        </component>
                    </div>
                </div>

                <!-- 右侧：二维码 + 社媒 -->
                <div class="col qr">
                    <div class="qr-box">
                        <img v-if="qrUrl" :src="qrUrl" alt="官方微信" />
                        <div v-else class="qr-placeholder">二维码</div>
                    </div>
                    <div class="qr-caption">官方微信</div>

                    <div class="social">
                        <component
                            :is="s.href ? 'a' : 'router-link'"
                            v-for="s in socials"
                            :key="s.name"
                            class="social-item"
                            :href="s.href || undefined"
                            :to="s.to"
                        >
                            {{ s.name }}
                        </component>
                    </div>
                </div>
            </div>

            <!-- 友情链接 -->
     
        </div>

        <!-- 最底部版权条 -->
        <div class="bottom">
            <div class="bottom-inner">
                <div class="copy">
                    Copyright © 2009-2026 All Rights Reserved
                </div>
                <div class="meta">
                    版权所有：余姚市技明电器有限公司 | 备案号:浙ICP备2025162364号-1
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
// 你有二维码图片就填：new URL("../assets/qrcode.png", import.meta.url).href
const qrUrl = "http://static.wdaoyun.com/wdy/source/2026-01-08/JMewm.png";

const navGroups = [
    {
        title: "产品与服务",
        links: [
            { text: "全品类制造加工", to: { path: "/productService", query: { key: "brand" } } },
            { text: "工业定位灯系列", to: { path: "/", hash: "#product" } },
            { text: "四大核心品类", to: { path: "/", hash: "#biz" } },
            { text: "应用行业", to: "/solution" },
        ],
    },
    {
        title: "快速导航",
        links: [
            { text: "首页", to: "/" },
            { text: "客户案例", to: "/CustomerCases" },
            { text: "关于我们", to: "/AboutUs" },
            { text: "联系咨询", href: "tel:13958349372" },
        ],
    },
    {
        title: "关于我们",
        links: [
            { text: "公司简介", to: "/AboutUs" },
            { text: "新闻动态", to: "/" },
            { text: "联系方式", href: "mailto:17371988805@163.com" },
        ],
    },
];

const socials = [
    { name: "制造加工", to: { path: "/productService", query: { key: "brand" } } },
    { name: "合作联系", href: "tel:13958349372" },
    { name: "进出口业务", to: { path: "/productService", query: { key: "brand" } } },
];

</script>

<style scoped>
/* ✅ 背景铺满且不出横向滚动条：用伪元素 */
.footer {
    position: relative;
    overflow: hidden;
    color: rgba(255, 255, 255, .78);
}

.footer::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(160deg, #0c2039 0%, #0a1a30 100%);
    z-index: 0;
}

.footer>* {
    position: relative;
    z-index: 1;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 44px 18px 0;
}

.top {
    display: grid;
    grid-template-columns: 420px 1fr 260px;
    gap: 40px;
    align-items: start;
}

/* 左侧品牌 */
.brand-row {
    display: flex;
    align-items: center;
    gap: 14px;
}

.brand-mark {
    height: 54px;
    width: auto;
    max-width: 150px;
    object-fit: contain;
    border-radius: 12px;
    /* background: rgba(255, 255, 255, .08); */
    padding: 4px;
    flex: 0 0 auto;
}

.brand-name {
    flex: 1;
    min-width: 0;
}

.brand-name .cn {
    font-size: 24px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 1px;
}

.brand-name .en {
    margin-top: 4px;
    font-size: 12px;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, .55);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact {
    margin-top: 18px;
    display: grid;
    gap: 12px;
}

.item {
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

.ico {
    width: 22px;
    opacity: .85;
}

.txt {
    line-height: 1.8;
    font-size: 14px;
}

/* 中间导航 */
.nav {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 34px;
}

.nav-title {
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    margin-bottom: 12px;
    position: relative;
}

.nav-title::after {
    content: "";
    display: block;
    width: 24px;
    height: 2px;
    background: rgba(255, 255, 255, .25);
    margin-top: 10px;
}

.nav-link {
    display: block;
    padding: 7px 0;
    color: rgba(255, 255, 255, .65);
    font-size: 14px;
}

.nav-link:hover {
    color: #fff;
}

/* 右侧二维码 */
.qr {
    text-align: center;
}

.qr-box {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    background: rgba(255, 255, 255, .06);
    border: 1px solid rgba(255, 255, 255, .10);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.qr-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.qr-placeholder {
    color: rgba(255, 255, 255, .7);
    font-weight: 800;
}

.qr-caption {
    margin-top: 12px;
    color: rgba(255, 255, 255, .7);
    font-size: 14px;
}

.social {
    margin-top: 20px;
    display: flex;
    gap: 18px;
    justify-content: center;
}

.social-item {
    color: rgba(255, 255, 255, .75);
    font-weight: 700;
}

.social-item:hover {
    color: #fff;
}

/* 友情链接 */
.links {
    margin-top: 34px;
    padding-top: 22px;
    border-top: 1px solid rgba(255, 255, 255, .10);
}

.links-title {
    font-size: 16px;
    font-weight: 800;
    color: rgba(255, 255, 255, .85);
}

.links-row {
    margin-top: 14px;
    display: flex;
    flex-wrap: wrap;
    gap: 18px 28px;
    align-items: center;
}

.f-link {
    color: rgba(255, 255, 255, .58);
    font-size: 14px;
}

.f-link:hover {
    color: #fff;
}

.more {
    margin-left: auto;
    color: rgba(255, 255, 255, .75);
}

/* 底部黑条 */
.bottom {
    margin-top: 30px;
    background: #081426;
}

.bottom-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px 18px;
    display: flex;
    justify-content: center;
    gap: 28px;
    flex-wrap: wrap;
    color: rgba(255, 255, 255, .62);
    font-size: 13px;
}

/* 响应式 */
@media (max-width: 1100px) {
    .top {
        grid-template-columns: 1fr;
        gap: 26px;
    }

    .nav {
        grid-template-columns: repeat(2, 1fr);
    }

    .more {
        margin-left: 0;
    }
}

@media (max-width: 520px) {
    .nav {
        grid-template-columns: 1fr;
    }

    .qr-box {
        width: 140px;
        height: 140px;
    }
}
</style>
